<template>
  <section id="projects" class="pt-5">
    <div class="container">
      <div class="col-12">
        <h2 class="project-head text-gradient-gold fw-bold">
          Featured projects:
        </h2>
        <p class="text-white">
          I have worked on many projects over the course of being a Web
          Developer, here are a few of my live, real-world projects
        </p>

        <!-- PROJECTS BLOCK STARTS HERE -->
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 p-4 project-card">
            <div class="project-wrapper p-4 rounded">
              <div class="image-area">
                <img
                  src="https://cdn.hashnode.com/res/hashnode/image/upload/v1700259249439/eac8730e-5c06-4bb3-bddf-6351956b6b01.png"
                  alt=""
                  class="rounded"
                />
              </div>
              <p
                class="project-title fw-bolder text-gradient-gold text-uppercase mt-2"
              >
                TIIDELab website
              </p>
              <p class="project-description text-white">
                Social Platform that promote Self-Reliant Software developers
              </p>
              <div class="btn-wrapper">
                <a href="https://tiidelab.com"
                  ><button
                    class="btn btn-block live-demo-btn btn-gradient-gold"
                  >
                    Live Demo
                    <font-awesome-icon icon="fa-solid fa-share" /></button
                ></a>
                <button class="btn btn-block github-link-btn ms-2" disabled>
                  Github Link
                </button>
              </div>
              <div class="stack-used mt-3">
                <font-awesome-icon
                  icon="fa-brands fa-html5"
                  class="fs-3 html-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-css3"
                  class="fs-3 ms-2 css-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-js"
                  class="fs-3 ms-2 javascript-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-react"
                  class="fs-3 ms-2"
                  style="color: #61dbfb"
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 24 24"
                  style="fill: #61dbfb; transform: ; msfilter;margin-top:-10px; "
                >
                  <path
                    d="M18.5 9.51a4.22 4.22 0 0 1-1.91-1.34A5.77 5.77 0 0 0 12 6a4.72 4.72 0 0 0-5 4 3.23 3.23 0 0 1 3.5-1.49 4.32 4.32 0 0 1 1.91 1.35A5.77 5.77 0 0 0 17 12a4.72 4.72 0 0 0 5-4 3.2 3.2 0 0 1-3.5 1.51zm-13 4.98a4.22 4.22 0 0 1 1.91 1.34A5.77 5.77 0 0 0 12 18a4.72 4.72 0 0 0 5-4 3.23 3.23 0 0 1-3.5 1.49 4.32 4.32 0 0 1-1.91-1.35A5.8 5.8 0 0 0 7 12a4.72 4.72 0 0 0-5 4 3.2 3.2 0 0 1 3.5-1.51z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 p-4 project-card">
            <div class="project-wrapper p-4 rounded">
              <div class="image-area">
                <img
                  src="https://cdn.hashnode.com/res/hashnode/image/upload/v1700664676687/8c46246e-46cf-4547-a668-f27bcf106ee9.png"
                  alt=""
                  class="rounded"
                  style="background-color: #000"
                />
              </div>
              <p
                class="project-title fw-bolder text-gradient-gold text-uppercase mt-2"
              >
                LANDSHOP NG
              </p>
              <p class="project-description text-white">
                A Real Estate Company Website
              </p>
              <div class="btn-wrapper">
                <a href="https://www.landshop.ng/"
                  ><button
                    class="btn btn-block live-demo-btn btn-gradient-gold"
                  >
                    Live Demo
                    <font-awesome-icon icon="fa-solid fa-share" /></button
                ></a>
                <button class="btn btn-block github-link-btn ms-2" disabled>
                  Github Link
                </button>
              </div>
              <div class="stack-used mt-3">
                <font-awesome-icon
                  icon="fa-brands fa-html5"
                  class="fs-3 html-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-css3"
                  class="fs-3 ms-2 css-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-js"
                  class="fs-3 ms-2 javascript-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-bootstrap"
                  class="fs-3 ms-2 bootstrap-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-vuejs"
                  class="fs-3 ms-2 vue-logo"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 p-4 project-card">
            <div class="project-wrapper p-4 rounded">
              <div class="image-area">
                <img
                  src="https://cdn.hashnode.com/res/hashnode/image/upload/v1700664871318/13250d70-e3ab-4de7-a693-5b319b8f62ee.png"
                  alt=""
                  class="rounded"
                  style="background-color: #000"
                />
              </div>
              <p
                class="project-title fw-bolder text-gradient-gold text-uppercase mt-2"
              >
                afro verified
              </p>
              <p class="project-description text-white">
                An Event Ticket Management System
              </p>
              <div class="btn-wrapper">
                <a href="https://avf-frontend.vercel.app/"
                  ><button
                    class="btn btn-block live-demo-btn btn-gradient-gold"
                  >
                    Live Demo
                    <font-awesome-icon icon="fa-solid fa-share" /></button
                ></a>
                <button class="btn btn-block github-link-btn ms-2" disabled>
                  Github Link
                </button>
              </div>
              <div class="stack-used mt-3">
                <font-awesome-icon
                  icon="fa-brands fa-html5"
                  class="fs-3 html-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-css3"
                  class="fs-3 ms-2 css-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-js"
                  class="fs-3 ms-2 javascript-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-bootstrap"
                  class="fs-3 ms-2 bootstrap-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-vuejs"
                  class="fs-3 ms-2 vue-logo"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 p-4 project-card">
            <div class="project-wrapper p-4 rounded">
              <div class="image-area">
                <img :src="projectImage" alt="" class="rounded bg-white" />
              </div>
              <p
                class="project-title fw-bolder text-gradient-gold text-uppercase mt-2"
              >
                {{ name }}
              </p>
              <p class="project-description text-white">
                {{ description }}
              </p>
              <div class="btn-wrapper">
                <a :href="liveLink"
                  ><button
                    class="btn btn-block live-demo-btn btn-gradient-gold"
                  >
                    Live Demo
                    <font-awesome-icon icon="fa-solid fa-share" /></button
                ></a>
                <button class="btn btn-block github-link-btn ms-2" disabled>
                  Github Link
                </button>
              </div>
              <div class="stack-used mt-3">
                <div v-html="css"></div>
                <!-- {{ css }} -->
                <!-- <font-awesome-icon
                  icon="fa-brands fa-html5"
                  class="fs-3 html-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-css3"
                  class="fs-3 ms-2 css-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-js"
                  class="fs-3 ms-2 javascript-logo"
                />
                <font-awesome-icon
                  icon="fa-brands fa-bootstrap"
                  class="fs-3 ms-2 bootstrap-logo"
                /> -->
                <font-awesome-icon
                  icon="fa-brands fa-vuejs"
                  class="fs-3 ms-2 vue-logo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProjectComp",
  props: [
    "projectImage",
    "name",
    "description",
    "liveLink",
    "html",
    "css",
    "javascript",
    "react",
    "tailwindCss",
    "bootstrap",
    "vue",
  ],
  setup() {
    return {};
  },
};
</script>

<style scoped>
#projects {
  min-height: 100vh;
  padding-bottom: 100px;
}
.html-icon,
.css-icon,
.js-icon,
.vue-icon,
.git-icon,
.github-icon,
.laravel-icon,
.bootstrap-icon {
  color: #fff;
  font-size: 4rem;
}

.project-wrapper {
  background-color: var(--grayish-white);
}
.image-area > img {
  width: 100%;
  height: 200px;
  background-color: #fff;
}
.live-demo-btn,
.github-link-btn {
  color: #fff;
  background-color: transparent;
  border: 2px solid hsla(42, 65%, 41%, 1);
  transition: all 300ms ease-in;
  cursor: pointer;
}
.live-demo-btn {
  background-color: #ad8425;
}
.github-link-btn:hover {
  cursor: pointer;
  background: hsla(42, 65%, 41%, 1);
  background: linear-gradient(
    135deg,
    hsla(42, 65%, 41%, 1) 0%,
    hsla(56, 87%, 75%, 1) 94%
  );
  background: -moz-linear-gradient(
    135deg,
    hsla(42, 65%, 41%, 1) 0%,
    hsla(56, 87%, 75%, 1) 94%
  );
  background: -webkit-linear-gradient(
    135deg,
    hsla(42, 65%, 41%, 1) 0%,
    hsla(56, 87%, 75%, 1) 94%
  );
  filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#AE8625", endColorstr="#F7EF8A", GradientType=1 );
}
.html-logo {
  color: var(--html);
}
.css-logo {
  color: var(--css);
}
.bootstrap-logo {
  color: var(--bootstrap);
}
.laravel-logo {
  color: var(--laravel);
}
.javascript-logo {
  color: var(--javascript);
}
.vue-logo {
  color: var(--vue);
}
</style>
